import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const asideSizes = {
  default: ['100%', '100%', '382px', '382px', '382px', '482px'],
  large: ['100%', '100%', '100%', '100%', '654px'],
  frontConfigurator: ['100%', '100%', '100%', '100%', '33.1770833vw'],
  medium: ['100%', '100%', '100%', '402px', '402px']
};
export default {
  overlay: (active: boolean, useCurtain: boolean | undefined) => ({
    background: useCurtain ? 'rgba(0,0,0,0.7)' : 'transparent',
    display: 'block',
    width: useCurtain ? '100%' : 'auto',
    height: `100%`,
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: theme.zIndex.aside,
    ...(active ? {
      opacity: 1,
      pointerEvents: 'auto',
      visibility: 'visible'
    } : {
      opacity: 0,
      pointerEvents: 'none',
      visibility: 'hidden'
    }),
    ...reusables.mainTransition('opacity'),
    willChange: 'opacity'
  }),
  aside: (active: boolean, size: 'default' | 'large' | 'frontConfigurator' | 'medium', overflowY = 'auto', overflowX = 'hidden') => ({
    maxWidth: asideSizes[size],
    background: theme.rawColors.neutralWhite,
    border: '0px solid rgba(25, 25, 25, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    width: size === 'large' ? ['100%', '100%', '100%', '100%', '654px'] : '100%',
    height: `100%`,
    zIndex: theme.zIndex.aside,
    maxHeight: `100%`,
    overflowY: overflowY,
    overflowX: overflowX,
    right: '0',
    ...reusables.mainTransition('transform'),
    willChange: 'transform',
    borderLeftWidth: '1px',
    ...(active ? {
      transform: 'translateX(0px)',
      visibility: 'visible'
    } : {
      transform: 'translateX(100%)',
      visibility: 'hidden'
    })
  }),
  asideTitleContainer: {
    padding: ['18px 20px', '18px 20px', '18px 40px', '18px 40px', '38px 40px', '38px 40px']
  },
  asideContent: {
    padding: 0,
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  asideCloseButton: {
    zIndex: theme.zIndex.documentUp,
    top: ['16px', '16px', '16px', '16px', '34px', '34px'],
    right: ['16px', '16px', '24px', '24px', '40px', '40px'],
    position: 'absolute',
    display: 'inline-flex',
    ':focus-visible': {
      position: 'absolute'
    }
  }
};